@if (chartData(); as chartData) {
  <cfp-card [fullHeight]="true">
    <div class="d-flex">
      <h2 class="card-title">{{ 'total.usage' | translate }}</h2>
    </div>
    <div class="chart-responsive" aria-hidden="true">
      <div class="chart-wrapper">
        <canvas
          class="chart-canvas"
          baseChart
          [datasets]="chartData.datasets"
          [labels]="chartData.labels"
          [type]="chartType"
          [options]="chartOptions"
          role="img"
          [attr.aria-label]="getTranslation('roadmapChart.ariaLabel.usages')"
        >
        </canvas>
      </div>
    </div>
    <div class="mt-2 d-print-none">
      <cfp-link (click)="showData()">{{ 'show.data' | translate }} <cfp-icon [icon]="'angle-right'" /></cfp-link>
    </div>
  </cfp-card>
}
